import { render, staticRenderFns } from "./TextWithBadge.vue?vue&type=template&id=e93789d6&scoped=true&"
import script from "./TextWithBadge.vue?vue&type=script&lang=js&"
export * from "./TextWithBadge.vue?vue&type=script&lang=js&"
import style0 from "./TextWithBadge.vue?vue&type=style&index=0&id=e93789d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93789d6",
  null
  
)

export default component.exports